import { useTranslation } from 'react-i18next'

const HIDDEN_STYLE = {
  position: 'absolute',
  left: '-9999px',
  top: 'auto',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
} as const

export function SkipToMainContentLink() {
  const { t } = useTranslation()
  return (
    <a
      href="#main-content"
      style={HIDDEN_STYLE}
      onFocus={(e) => {
        e.currentTarget.style.position = 'fixed'
        e.currentTarget.style.left = '16px'
        e.currentTarget.style.top = '16px'
        e.currentTarget.style.width = 'auto'
        e.currentTarget.style.height = 'auto'
        e.currentTarget.style.overflow = 'visible'
        e.currentTarget.style.zIndex = '99999'
        e.currentTarget.style.background = '#fff'
        e.currentTarget.style.padding = '8px 16px'
        e.currentTarget.style.borderRadius = '4px'
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,.3)'
        e.currentTarget.style.color = '#269CA6'
        e.currentTarget.style.fontWeight = '600'
      }}
      onBlur={(e) => {
        e.currentTarget.style.position = 'absolute'
        e.currentTarget.style.left = '-9999px'
        e.currentTarget.style.width = '1px'
        e.currentTarget.style.height = '1px'
        e.currentTarget.style.overflow = 'hidden'
      }}
    >
      {t('common:skipToMainContent', { defaultValue: 'Skip to main content' })}
    </a>
  )
}
